function BusinessSourceReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">BusinessSourceReport</div>
      </>
    );
  }
  
  export default BusinessSourceReport;